import { FEATURE_FLAG as CONSENT_FEATURE_FLAG } from '@buzzfeed/consent';

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  CONSENT_FEATURE_FLAG,
  {
    name: 'TimeSpentRO_4',
    variations: ['on', 'control'],
    isEligible: () => true,
  },
];
